import ShDividerLine from '@/components/Helpers/ShDividerLine';

// @vue/component
export default {
  name: 'AccountSettingsMenu',

  components: {
    ShDividerLine,
  },

  computed: {
    accessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'];
    },
  },

  methods: {
    handleLogout() {
      this.$auth.logoutFromPlatform();
    },
  },
};
